import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledAbout = styled.div`
    margin-top: 6.5rem;
    @media ${breakpoints.xs} {
        margin-top: 1.6rem;
    }
`;

export const StyledBodyTitle = styled.span`
    display: flex;
    align-items: center;
    margin-bottom: 1.6rem;
    font-size: var(--size-14);
    font-style: normal;
    font-weight: bold;
    line-height: 19px;
    color: var(--color-secondary);
    text-transform: uppercase;
`;

export const StyledInfoBodyTitle = styled.span`
    display: flex;
    align-items: center;
    font-size: var(--size-16);
    font-style: normal;
    font-weight: normal;
    line-height: 20px;
    color: var(--color-grey-800);
    @media ${breakpoints.sm} {
        font-size: var(--size-12);
    }
`;

export const StyledInfo = styled.div`
    margin-top: 2.6rem;
`;

export const StyledInfoTitle = styled.span`
    display: flex;
    align-items: center;
    font-size: var(--size-18);
    font-style: normal;
    font-weight: bold;
    line-height: 25px;
    color: var(--color-primary);
    text-transform: uppercase;
    @media ${breakpoints.sm} {
        font-size: var(--size-14);
    }
`;

export const StyledDetailsContainer = styled.div`
    margin-top: 3.2rem;
`;

export const StyledDetails = styled.div`
    display: flex;
    padding-left: 1rem;
    margin-bottom: 1.6rem;
    @media ${breakpoints.xs} {
        display: block;
    }
`;

export const StyledInfoBody = styled.span`
    display: flex;
    align-items: center;
    width: 20%;
    font-size: var(--size-16);
    font-style: normal;
    font-weight: normal;
    line-height: 20px;
    color: var(--color-grey-800);
    @media ${breakpoints.sm} {
        font-size: var(--size-12);
    }
    @media ${breakpoints.xs} {
        width: auto;
    }
`;

export const StyledInfoBodyDetails = styled.span`
    display: flex;
    align-items: center;
    font-size: var(--size-16);
    font-style: normal;
    font-weight: var(--weight-600);
    line-height: 20px;
    color: var(--color-grey-900);
    @media ${breakpoints.sm} {
        font-size: var(--size-12);
    }
`;
